import axios from 'axios'

const getBaseUrl = () =>
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:8080/api'
        : process.env.REACT_APP_BASE_URL

export default axios.create({
    baseURL: getBaseUrl(),
})
